import { spacingTokens } from './spacing';
import {
  colorBackgroundDefaultTokens,
  colorBorderDefaultTokens,
  colorTextDefaultTokens
} from './color';

const tokenList: { [key: string]: string } = Object.freeze({
  ...spacingTokens,
  ...colorBackgroundDefaultTokens,
  ...colorBorderDefaultTokens,
  ...colorTextDefaultTokens
});

export default tokenList;
